import { create } from "../../../common/utils/zustand_state_manager";
import { QualidadeRepository } from "../../../features/qualidade/data/repositories/qualidade_repository";
import { IQualidadeRepository } from "../../../features/qualidade/domain/repositories/qualidade_repository";
import { useQualidadeService } from "./use_services";


//useAuditorRepositories

type State = {
  qualidadeRepository: IQualidadeRepository,
};

export const useQualidadeRepositories = create<State>((set, get) => {
  const { qualidadeService } = useQualidadeService.getState();
  return ({
    qualidadeRepository: new QualidadeRepository(qualidadeService),
  });
});